import { useMemo } from "react"
import { FetchState } from "shared/api"
import { dateFormat } from "shared/util"

import { MrpProjectResultList } from "interface/carenet/mrp"

import {
	FormControl,
	InputLabel,
	MenuItem,
	Select,
  Stack,
  Typography
} from "@mui/material"

import { Loading } from "components/controls/loading"

const empty = "**"

type MrpProjectSelectProps = {
  projectsState: FetchState<MrpProjectResultList>
  projectId: number | null
  setProjectId: (projectId: number | null) => void
  maxWidth?: string
}
export const MrpProjectSelect = ({
  projectsState,
  projectId,
  setProjectId,
  maxWidth
}: MrpProjectSelectProps) => {
  const projects = useMemo(
    () => {
      if (projectsState.loading) return []
      const projects = projectsState.data?.list || []
      projects.sort((a, b) => (b.startDate ?? '').localeCompare(a.startDate ?? ''))
      return projects
    },
    [projectsState]
  )
  return (
    <FormControl sx={{ position: 'relative' }}>
      {projectsState.loading && <Loading/>}
      <InputLabel id="mrp-project-id-label">MRP</InputLabel>
      <Select
        id="mrp-project-id"
        labelId="mrp-project-id-label"
        label="MRP"
        size="small"
        fullWidth
        value={projectId ? `${projectId}` : empty}
        onChange={
          (event) => setProjectId(
            event.target.value === empty ? null : Number(event.target.value)
          )
        }
        renderValue={(selected) => {
          if (selected === empty) return "未選択"
          const selectedId = Number(selected)
          const project = projects.find((project) => project.projectId === selectedId)
          return (
            <div
              dangerouslySetInnerHTML={{
                __html: project?.projectName ?? 'empty'
              }}
              style={{
                maxWidth,
                whiteSpace: 'nowrap',
                overflow: 'hidden',
                textOverflow: 'ellipsis'
              }}
            />
          )
        }}
      >
        <MenuItem key={`choice-empty`} value={empty}>
          未選択
        </MenuItem>

        { projects.map((project) => (
          <MenuItem key={`mrp-project-${project.projectId}`} value={`${project.projectId}`}>
            <Stack direction="row" spacing={0.5} alignItems="center" width="100%">
              <Typography variant="body2" color="text.secondary" width="8em">{dateFormat(project.startDate, { wareki: false })}</Typography>
              <div
                dangerouslySetInnerHTML={{
                  __html: project.projectName ?? 'empty'
                }}
                style={{
                  whiteSpace: 'nowrap',
                  maxWidth: '50vw',
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                  flexGrow: 1
                }}
              />
              <Typography variant="body2" color="text.secondary">{project.productName}</Typography>
            </Stack>
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  )
}
